/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-10 21:09:41
 */
import React, { useEffect, useState, ChangeEvent } from 'react'
import type { TableConfig } from '../types'

interface CellProps {
  i: number
  j: number
  tableData: string[][]
  setTableData: (data: string[][]) => void
  textAlign: 'left' | 'center' | 'right'
}

const Cell = ({ i, j, tableData, setTableData, textAlign }: CellProps) => {
  return (
    <div
      style={{
        maxWidth: `${600 / j}px`,
        borderLeft: '.5px solid #DEE0E3',
        borderBottom: '.5px solid #DEE0E3',
        padding: '4px',
        minHeight: '3em',
        display: 'flex',
        alignItems: 'center',
        background: i === 0 ? '#F8F8F8' : '#ffffff'
      }}
    >
      <textarea
        className="table-input"
        rows={1}
        style={{
          width: '100%',
          minHeight: '20px',
          background: i === 0 ? '#F8F8F8' : '#ffffff',
          textAlign: textAlign
        }}
        value={tableData[i][j]}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
          const newData = [...tableData]
          newData[i][j] = e.target.value
          setTableData(newData)
        }}
      />
    </div>
  )
}

interface DynamicGridTableProps {
  config: TableConfig
  onChange: (config: TableConfig) => void
}

const DynamicGridTable = ({ config, onChange }: DynamicGridTableProps) => {
  const { rows, cols, cellAlign, tableSwitch, data } = config

  const generateGridStyles = (): React.CSSProperties => {
    return {
      display: 'grid',
      gridTemplateRows: `repeat(${rows}, minmax(${1.5}em, auto))`,
      gridTemplateColumns: `repeat(${cols}, 1fr)`,
      borderRight: '.5px solid #DEE0E3',
      borderTop: '.5px solid #DEE0E3'
    }
  }

  useEffect(() => {
    const textareas = document.querySelectorAll<HTMLTextAreaElement>('.table-input')
    textareas.forEach((textarea) => {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    })
  }, [data, tableSwitch])

  const generateGridItems = () => {
    const gridItems: React.ReactNode[] = []

    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        gridItems.push(
          <Cell
            key={`${i}-${j}`}
            i={i}
            j={j}
            tableData={data}
            setTableData={(tableData: string[][]) => {
              onChange({
                ...config,
                data: tableData
              })
            }}
            textAlign={cellAlign}
          />
        )
      }
    }

    return gridItems
  }

  if (tableSwitch) {
    return (
      <div className="dynamic-grid-table">
        <div style={generateGridStyles()}>{generateGridItems()}</div>
      </div>
    )
  }
  return null
}

export default DynamicGridTable
